import parse from "html-react-parser"
import { useTranslation } from "react-i18next"

import { AIFlowDiagram } from "@/features/training/components/ai-flow-diagram"
import { CourseList } from "@/features/training/components/course-list"
import { CourseLayout } from "@/features/training/components/layouts/course-layout"
import { CourseSection } from "@/features/training/components/layouts/course-section"

export function RAGPage() {
  const { t } = useTranslation("", { keyPrefix: "training.rag" })
  const bulletPoints = t("content.bullet_points", { returnObjects: true }) as string[]

  return (
    <CourseLayout>
      <CourseSection>
        <h2> {t("content.rag")}</h2>
        <p>{parse(t("content.rag_intro"))}</p>
        <p>{parse(t("content.figure_1"))}</p>
        <img
          alt="Description"
          className="bg-foreground h-25 w-full rounded-[6px] dark:bg-transparent"
          src="/assets/training_images/challenges/ai-svar_en.png"
        />
      </CourseSection>
      <CourseSection>
        <h3> {t("content.explanation_header")}</h3>
        <p>{parse(t("content.explaination"))}</p>
      </CourseSection>
      <CourseSection>
        <h3> {t("content.process_header")}</h3>
        <img
          alt="Beskrivning"
          className="bg-foreground size-full max-h-[500px] rounded-[6px] dark:bg-transparent"
          src="/assets/training_images/challenges/RAG_en.png"
        />
      </CourseSection>
      <CourseSection>
        <p>{parse(t("content.process_steps"))}</p>
        <h3> {t("content.benefits_header")}</h3>
        <CourseList data={bulletPoints} />
      </CourseSection>

      {/* Visual flow diagrams */}
      <CourseSection>
        <h2>{t("content.flow_diagram_title", "How It Works — Visually")}</h2>
        <AIFlowDiagram />
      </CourseSection>
    </CourseLayout>
  )
}
